function modal () {
  const html = document.querySelector('html')
  const modaLinks = document.querySelectorAll('.open-modal')
  const btnClose = document.querySelectorAll('.modal .close')
  const allModals = document.querySelectorAll('.modal')
  // console.log(btnClose);
  let propertySwiper = null

  function closeModal (html, modal) {
    html.dataset.modal = 'off'
    modal.dataset.show = 'off'
    
    // Destruir el swiper de propiedad si existe
    if (propertySwiper) {
      propertySwiper.destroy()
      propertySwiper = null
    }
  }

  // Función para manejar el clic fuera del elemento
  function handleClickOutside (html, modal, modalContent, modalType, event) {
    if (!modalContent.contains(event.target)) {
      // console.log('Se hizo clic fuera del elemento.');

      if (modalType === 'gallery') {
        setTimeout(() => gallerySwiper.destroy(), 1000)
      }

      closeModal(html, modal)
    }
  }

  // Función para cargar las imágenes de la galería de la propiedad
  function loadPropertyGallery(propertySlug, modal) {
    // Acceder directamente a los datos de propiedades a través de una variable global
    if (window.propertiesData && Array.isArray(window.propertiesData)) {
      // Buscar la propiedad directamente por su slug
      const property = window.propertiesData.find(p => p.slug === propertySlug);
      
      // Registrar en consola para depuración
      // console.log('Buscando propiedad con slug:', propertySlug);
      // if (property) {
      //   console.log('Propiedad encontrada:', property.title);
      // } else {
      //   console.log('No se encontró ninguna propiedad con ese slug');
      // }
      
      // Manejar el botón de sitio web
      const websiteContainer = modal.querySelector('#property-website')
      const websiteLink = websiteContainer ? websiteContainer.querySelector('a') : null
      
      if (websiteContainer) {
        if (property && property.www) {
          // Si la propiedad tiene URL de sitio web, mostrar el botón y establecer el enlace
          websiteContainer.style.display = 'flex'
          if (websiteLink) {
            websiteLink.href = property.www
          }
        } else {
          // Si no tiene URL, ocultar el botón
          websiteContainer.style.display = 'none'
        }
      }
      
      // Manejar la descripción de la propiedad
      const propertyDesc = modal.querySelector('#property-desc')
      if (propertyDesc) {
        if (property && property.desc) {
          // Si la propiedad tiene descripción, mostrarla
          propertyDesc.textContent = property.desc
        } else {
          // Si no tiene descripción, dejar el elemento vacío
          propertyDesc.textContent = ''
        }
      }
      
      // Cargar la galería de imágenes
      if (property && property.gallery && property.gallery.length > 0) {
        // Obtener el contenedor del swiper
        const swiperWrapper = modal.querySelector('.swiper-property .swiper-wrapper')
        
        // Limpiar el contenedor
        swiperWrapper.innerHTML = ''
        
        // Crear los slides para cada imagen
        property.gallery.forEach(img => {
          const slide = document.createElement('div')
          slide.className = 'swiper-slide'
          slide.innerHTML = `<img src="public/img/gallery/${property.slug}/${img}" alt="${property.title}">`
          swiperWrapper.appendChild(slide)
        })
        
        // Inicializar el swiper
        import('swiper').then(({ default: Swiper }) => {
          import('swiper/modules').then(({ Navigation, Pagination }) => {
            // Destruir el swiper existente si hay uno
            if (propertySwiper) {
              propertySwiper.destroy()
            }
            
            // Inicializar el nuevo swiper
            propertySwiper = new Swiper('.swiper-property', {
              modules: [Navigation, Pagination],
              loop: true,
              navigation: {
                nextEl: '.swiper-property .swiper-button-next',
                prevEl: '.swiper-property .swiper-button-prev'
              },
              pagination: {
                el: '.swiper-property .swiper-pagination',
                clickable: true
              }
            })
          })
        })
      }
    } else {
      console.error('Error: No se encontraron datos de propiedades')
    }
  }

  modaLinks.forEach((btnModal) => {
    btnModal.onclick = (e) => {
      e.preventDefault()
      e.stopPropagation() // Detiene la propagación del evento

      /* open modal */
      const modaLink = btnModal.dataset.modal

      const modal = document.querySelector(
        '.modal[data-modal=' + modaLink + ']'
      )

      const modalType = modal.dataset.type
      html.dataset.modal = 'on'
      modal.dataset.show = 'on'

      // Si el elemento que abre el modal es una card
      if (btnModal.classList.contains('card')) {
        const cardTitle = btnModal.querySelector('h3')?.innerText || ''
        const propertySlug = btnModal.dataset.property || ''
        const propertyInput = modal.querySelector('input[name="property"]')
        
        if (propertyInput) {
          propertyInput.value = cardTitle
        }
        
        // Colocar el valor en .property-name
        const propertyNameDiv = modal.querySelector('.property-name')
        if (propertyNameDiv) {
          propertyNameDiv.textContent = cardTitle
        }
        
        // Cargar la galería de imágenes si tenemos el slug de la propiedad
        if (propertySlug) {
          loadPropertyGallery(propertySlug, modal)
        }
      }

      /* video play */
      if (modalType === 'video') {
        const modalVideo = modal.querySelector('video')
        modalVideo.play()
        modal.addEventListener('click', (e) => {
          modalVideo.pause()
        })
      }

      /* iframe play */
      if (modalType === 'iframe') {
        const modalIframe = modal.querySelector('iframe')
        const modalIframeSrc = modalIframe.dataset.src
        modalIframe.set('src', modalIframeSrc)
        modal.addEventListener('click', (e) => {
          modalVideo.pause()
        })
      }
    } // click
  })

  // Cerrar Modal al clickear fuera del contenido
  allModals.forEach((modal) => {
    modal.addEventListener('click', (event) => {
      const modalContent = modal.querySelector('.modal-box')
      const modalType = modal.dataset.type
      handleClickOutside(html, modal, modalContent, modalType, event)
    })
  })

  // Cerrar Modal al clickear el botón cerrar
  if (btnClose) {
    btnClose.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault()

        const thisModal = close.closest('.modal')

        thisModal.dataset.show = 'off'

        setTimeout(() => {
          html.dataset.modal = 'off'
        }, 300)
      })
    })
  } // btnClose
}

export default modal
